// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title[data-v-790476aa]{font-size:18px;font-weight:700}.detail[data-v-790476aa]{color:rgba(0,0,0,.45)}.detail>span[data-v-790476aa]{margin-right:16px}.detail .icon[data-v-790476aa]{margin-right:6px}[data-v-790476aa] .ant-divider-horizontal{margin:12px 0}", ""]);
// Exports
module.exports = exports;
